import { useForm } from "react-hook-form";
import { CircularProgress } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { Login } from "../../../store/actions";
import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import GoogleIcon from "@mui/icons-material/Google";
import FacebookIcon from "@mui/icons-material/Facebook";
import { v4 as uuid } from "uuid";
import { payrollActions } from "../../../store";
import axios from "axios";
import { loginAdminUrl } from "../../../Library/URLs";
import { HiMail } from "react-icons/hi";
import { IoMdLock } from "react-icons/io";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { toast } from "react-toastify";

const LoginDetail = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const unique_id = uuid();
  // const loading = useSelector((state)=>state.payroll.isLoading)
  const dispatch = useDispatch();
  const islogIn = useSelector((state) => state.payroll.isLogIn);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  const LogUser = async (Post) => {
    setLoading(true);
    const data = {
      email: Post.email,
      password: Post.password,
    };
    await axios.post(loginAdminUrl, data).then((res) => {
      if (res.data?.success===false) {
        toast.error(res?.data?.message);
      } else if(res?.data?.success === true) {
        dispatch(payrollActions.fetchId(unique_id));
        dispatch(payrollActions.getUser(res.data?.data));
        dispatch(payrollActions.authLogin(true));
        
        if (res.data?.member_type === "Employee") {
          navigate("/employee-dashboard");
        } else {
          // navigate("/dashboard");
          navigate("/companies")
        }
      } else {
        toast.error("An error occured!!!!");
      }
      setLoading(false);
    });
  };

  const handle = (data) => {
    // console.log('Post data',data)
    LogUser(data);
    // dispatch(Login(data))
  };

  useEffect(() => {
    if (islogIn === true) {
      reset();
    }
  }, [islogIn, reset]);

  // useEffect(() => {
  //   dispatch(payrollActions.fetchId(unique_id));
  // }, [dispatch, unique_id]);
  useEffect(() => {
    dispatch(payrollActions.fetchId(unique_id));
  }, []);
  return (
    <div className="Form">
      <h4>Welcome!</h4>
      <div className="Manage_Text">I4smart Admin Application</div>
      <div className="Input_Box">
        <HiMail className="left_icon" />
        {/* <label htmlFor="username">Username</label> */}
        <input
          type="text"
          id="mail"
          placeholder="User ID or Email"
          className={`${errors.email && "active"}`}
          {...register("email", { required: true })}
        />
        {errors.email && <p>email or user ID is required.</p>}
      </div>
      <div className="Input_Box Last_child">
        {/* <label htmlFor="password">Password</label> */}
        <IoMdLock className="left_icon" />
        <input
          type={showPassword?"text":"password"}
          id="password"
          placeholder="At least 8 characters"
          className={`${errors.password && "active"}`}
          {...register("password", { required: true })}
        />
        {showPassword ? (
          <AiFillEyeInvisible
            onClick={() => setShowPassword(false)}
            className="right_icon"
          />
        ) : (
          <AiFillEye
            onClick={() => setShowPassword(true)}
            className="right_icon"
          />
        )}
        {errors.password && <p>password is required.</p>}
      </div>
      <div className="Button_Box">
        <Link className="forgot_link">Forgot Password?</Link>
        <div className="Btn" onClick={handleSubmit(handle)}>
          {loading === true ? (
            <CircularProgress color="inherit" size={20} />
          ) : (
            "Log in"
          )}
        </div>
      </div>
      {/* <div className="Horizontal_Line">
        <hr /> <span>or</span> <hr />
      </div>
      <div className="Social_Handle">
        <div className="Box">
          <GoogleIcon /> Google
        </div>
        <div className="Box">
          <FacebookIcon />
          Facebook
        </div>
      </div> */}
      {/* <div className="Sign_Up">
                        Don't you have an account ? <Link>Sign Up</Link>
                    </div> */}
    </div>
  );
};

export default LoginDetail;
